// extracted by mini-css-extract-plugin
export default {"item":"sort-items_item__0eSde","chevrons":"sort-items_chevrons__mExDX"};